module.exports = __webpack_public_path__ + "987c2ea0d342e1f8830b23f9173fee39.svg";